/* eslint-disable */
import { take, put, takeEvery } from "redux-saga/effects";
import { httpPost } from "../../Utils/apis/apis";
import * as manualActions from "../actions/manualAction";
import { manualUpdateActionType } from "../actions/actionTypes";
import { ErrorMsg } from "../../Utils/config/config";

let apiUrl = `${process.env.API_URL}/ChartData/getchartdata`;

export function* getManualUpdateSaga() {
  while (true) {
    const action = yield take(manualUpdateActionType.GET_DROPDOWN_VALUE);
    const {
      crmId,
      pageUrl,
      getMetricDropdownChartId,
      getMetricDropdownValue,
      getMetricDropdownKey,
      pagefilters
    } = action.payload;
    let params = {
      parameters: {},
      content: { sourceId: `${crmId}`, sourceLabel: `${pageUrl}` },
      chartId: getMetricDropdownChartId,
    };
    params.parameters[getMetricDropdownKey] =
      getMetricDropdownValue && getMetricDropdownValue.toLowerCase() === "=crmid"
        ? crmId
        : getMetricDropdownValue;
    if (pagefilters) {
      params = {
        ...params,
        parameters: { ...params.parameters, ...pagefilters },
      };
    }
    try {
      let res = yield httpPost(apiUrl, params);
      yield put(
        manualActions.getDropdownValueSucceeded({
          data: res.data,
          stateUpdated: true,
        })
      );
    } catch (e) {
     yield put(
        manualActions.getDropdownValueFailed({
          msg: ErrorMsg.ERROR,
          stateUpdated: false,
        })
      );
      console.log(e.message);
    }
  }
}

export function* getMetricDataTableSaga() {
  yield takeEvery(manualUpdateActionType.GET_DT_VALUE, getMetricDataTable);
}

export function* getMetricDataTable(action) {
  const {
    crmId,
    pageUrl,
    metricId,
    getMetricDataTableChartId,
    getMetricDataTableKey,
    pageFilterId,
  } = action.payload;
  const params = {
    parameters: {
      metric: metricId,
      ...pageFilterId,
    },
    content: { sourceId: crmId, sourceLabel: pageUrl },
    chartId: getMetricDataTableChartId,
  };
  params.parameters[getMetricDataTableKey] = crmId;
  try {
    let res = yield httpPost(apiUrl, params);
    yield put(
      manualActions.getMetricDTValueSucceeded({
        data: res.data,
        stateUpdated: true,
      })
    );
  } catch (e) {
    yield put(
      manualActions.getMetricDTValueFailed({
        msg: ErrorMsg.ERROR,
        stateUpdated: false,
      })
    );
    console.log(e.message);
  }
}
